import { ActionExecuteType } from "@/includes/types/Post.types";
import { PostActionStructure } from "../ActionTypes/PostActionStructure";

export class PostAction extends PostActionStructure {
    delay = 0
    execute_type: ActionExecuteType = ActionExecuteType.Parallel
}